import { pipe, map, pathOr, applySpec, propOr, prop, path, replace, find, pathEq } from 'ramda';
import { formatDate } from 'utilities/formatters';
import i18n from 'services/i18n';

export const handleAlertsData = pipe(
  pathOr([], ['entry']),
  map(
    pipe(
      propOr({}, 'resource'),
      applySpec({
        lastUpdated: pipe(
          path(['meta', 'lastUpdated']),
          formatDate('DD/MM/YY, hh:mm'),
        ),
        patientId: pipe(
          pathOr('-', ['subject', 'reference']),
          replace('Patient/', ''),
        ),
        status: pipe(
          propOr([], 'component'),
          find(pathEq(['code', 'coding', '0', 'code'], 'device_status')),
          prop('valueString'),
        ),
        id: prop('id'),
        reviewedOn: pipe(
          propOr([], 'component'),
          find(pathEq(['code', 'coding', '0', 'code'], 'reviewed_datetime')),
          prop('valueDateTime'),
          dateTime =>
            dateTime
              ? formatDate(i18n.t('dateTimeFormat.reportRecentDate'))(dateTime)
              : i18n.t('reports.reviewStatuses.unread'),
        ),
        markedReadOn: pipe(
          propOr([], 'component'),
          find(pathEq(['code', 'coding', '0', 'code'], 'patient_review_datetime')),
          prop('valueDateTime'),
          dateTime =>
            dateTime
              ? formatDate(i18n.t('dateTimeFormat.reportRecentDate'))(dateTime)
              : i18n.t('reports.reviewStatuses.unread'),
        ),
        openedOn: pipe(
          propOr([], 'component'),
          find(pathEq(['code', 'coding', '0', 'code'], 'opened_by_patient')),
          prop('valueDateTime'),
          dateTime =>
            dateTime
              ? formatDate(i18n.t('dateTimeFormat.reportRecentDate'))(dateTime)
              : i18n.t('reports.reviewStatuses.unopened'),
        ),
      }),
    ),
  ),
);
